<template>
  <div class="box"  :style="boxSettings">
    <div class="container">
      <div class="header">
       <figure class="image awsLogo">
          <img class="is-rounded imageWidth" :src="logo" />
        </figure>
        <div> 
          <h3 class="title is-size-3-mobile is-size-1-tablet" :style="quizLoginSettings">Welcome to {{quizName}}</h3>
          <h5 class="subtitle is-size-5-mobile is-size-3-tablet" :style="quizLoginSettings"> {{welcomeText}} </h5>
        </div>
      </div>
        <form @submit.prevent="register">
            <div class="field">
              <label class="label is-size-6-mobile is-size-4-tablet" :style="quizLoginSettings">Name</label>
              <div class="control">
                <input
                  class="input is-size-6-mobile is-size-4-tablet"
                  type="text"
                  v-model="userName"
                  :style="inputFieldSettings"
                  readonly
                />
              </div>
            </div>
            <div class="field">
              <label class="label is-size-6-mobile is-size-4-tablet" :style="quizLoginSettings">Organisation</label>
              <div class="control">
                <input
                  class="input is-size-6-mobile is-size-4-tablet"
                  type="email"
                  v-model="organisationName"
                  :style="inputFieldSettings"
                  readonly
                />
              </div>
            </div>
          <div class="center">
            <button class="button is-size-6-mobile is-size-4-tablet" :style="buttonSettings">GET STARTED!</button>
          </div>
        </form>
     
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ConfirmDetails',
  methods: {
    register() {
      this.$store.dispatch('readUserDetails');
    },
  },
  computed: {
    ...mapGetters(['quizName', 'organisationName', 'logo', 'backgroundColor', 'primaryColor', 'textColor', 'userName', 'welcomeText']),
      boxSettings(){
      return{
        "background-color": this.backgroundColor,
      }
    },
    inputFieldSettings(){
      return{
        "background-color": this.backgroundColor,
        "border-color": this.primaryColor,
        "color": this.textColor
        
      }
    },
    quizLoginSettings(){
      return{
        "color": this.textColor
        
      }
    },
    buttonSettings(){
      return{
        "background-color": this.primaryColor,
        "border-color": this.primaryColor,
        "color": this.textColor
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  width: 100vw;
  min-height: 100vh;


  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .title {
      color: $brand-color;
      font-weight: 600;
      line-height: 42px;
      text-align: center;
    }

    .subtitle {
      color: $brand-color;
      font-weight: 600;
      line-height: 42px;
      text-align: center;
    }

    .awsLogo{
        .imageWidth{
          width: 125px;
          height: 100px;
        }
      }
  }
  form {
    margin-top: 3vh;
    .field {
      .label {
        margin: 0px;
      }
      

      .input {
        border: 0px;
        border-bottom: 1px solid $primary-color;
        border-radius: 0px;
        height: 2em;
      }

      .help {
        font-family: Nunito Sans;
        font-style: normal;
        font-weight: 500;
        color: $help-background-color;
        visibility: visible;
        font-size: 1rem;
        margin-top: 0.15rem;
      }

      .noShow {
        font-family: Nunito Sans;
        font-style: normal;
        font-weight: 500;
        color: $app-background-color;
        visibility: hidden;
        display:block;
        font-size: 1rem;
        margin-top: 0.15rem;
      }
    }

    .checkBoxStyle {
      align-items: center;
      display: flex;
.check{
        align-self: flex-start;
    
    margin-top: 5px;
}
      
      }
    
    .center {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 2rem;

      .button {
        border-radius: 20px;
        font-weight: 600;
        font-size: 16px;
        text-transform: capitalize;
      }
    }
  }
}
</style>
